export default angular.module("mars.vet.dnareports.controllers.nocall",[])
		.controller('NoCallController', function($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService,DisorderDataService,reportdata) {
        'ngInject';

        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }
        EntryService.getEntry(EntryIDService.getEntryID('No Call')).then(function(response) {
            var fields = response.fields;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.title = fields.title;
            $scope.description = fields.description;
        
        });

        ImageService.getImageUrl('hHESnv8aSkayeuUkcIEOK').then(function(response) {
            $scope.mainStatusIcon = response.data.fields.file.url;
        });
        ImageService.getImageUrl('3fc0BjHymsymwmYkII4mMo').then(function(response) {
            $scope.subStatusIcon = response.data.fields.file.url;
        });

        $scope.translation = TranslationService.getTranslation;
		NavigationService.setNavigationUrls();
		$scope.nocallDataList = DisorderDataService.getNoCallData();
		$scope.locale = reportdata.locale;
	    $window.ga('send', 'pageview', {
	        'page': $scope.title
	    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/nocall.controller.js